import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, msalConfigOmdc } from './components/AuthConf';

let msalInstance = {}

if(localStorage.getItem("is_omdcUser") === "true"){
  msalInstance = new PublicClientApplication(msalConfigOmdc);
}else{
  msalInstance = new PublicClientApplication(msalConfig);
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <React.StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />   
          </MsalProvider>
        </BrowserRouter>
      </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
